import { jsx as _jsx } from "react/jsx-runtime";
import { RadioGroup } from '@bos/ui';
import { useController } from 'react-hook-form';
export const RadioGroupField = ({ control, name, registerOptions, ...appRadioGroupProps }) => {
    const { field, fieldState } = useController({
        control,
        name,
        defaultValue: undefined,
        ...registerOptions,
    });
    const { onChange, ...fieldRest } = field;
    const handleValueChange = (value) => {
        onChange(value);
    };
    const error = fieldState.error?.message;
    return (_jsx(RadioGroup, { ...fieldRest, ...appRadioGroupProps, error: error, onValueChange: handleValueChange }));
};
